import { createEntityAdapter } from '@reduxjs/toolkit';
import { State } from 'Libs/redux/types';
import { curry } from 'lodash';
import { EntityPlayers } from './entity-players.type';

export const entityPlayersAdapter = createEntityAdapter<EntityPlayers>({ selectId: (entity) => entity.entityId });

export const selectEntityPlayers = curry(
  (id: number, state: State) =>
    entityPlayersAdapter.getSelectors().selectById(state.entities.entityPlayers, id)?.players || [],
);

export const selectEntityPlayersMetadata = curry(
  (id: number, state: State) =>
    entityPlayersAdapter.getSelectors().selectById(state.entities.entityPlayers, id)?.metadata || {
      total: 0,
      loading: false,
      error: null,
      next: null,
    },
);
